module.exports = __webpack_public_path__ + "public/images/calendar.a7f18f0b2232e25cbc80bedfc2ceb5ba.webp";